import {
  GraduationCap,
  Award,
  MessageCircle,
  Megaphone,
  Clock,
  Trophy,
  Info,
  AlertTriangle,
  CheckCircle,
  XCircle,
} from 'lucide-react';
import type { NotificationType, NotificationTypeConfig } from './types';

/**
 * Notification Type Configuration
 * Maps each notification type to visual styling and metadata
 */
export const notificationTypeConfig: Record<NotificationType, NotificationTypeConfig> = {
  evaluation: {
    color: '#6D5DFE',
    bgColor: 'bg-purple-100 dark:bg-purple-900/30',
    textColor: 'text-purple-600 dark:text-purple-400',
    icon: GraduationCap,
    label: 'Nueva Evaluación',
  },
  grade: {
    color: '#10B981',
    bgColor: 'bg-green-100 dark:bg-green-900/30',
    textColor: 'text-green-600 dark:text-green-400',
    icon: Award,
    label: 'Calificación',
  },
  message: {
    color: '#3B82F6',
    bgColor: 'bg-blue-100 dark:bg-blue-900/30',
    textColor: 'text-blue-600 dark:text-blue-400',
    icon: MessageCircle,
    label: 'Mensaje',
  },
  announcement: {
    color: '#F59E0B',
    bgColor: 'bg-orange-100 dark:bg-orange-900/30',
    textColor: 'text-orange-600 dark:text-orange-400',
    icon: Megaphone,
    label: 'Anuncio',
  },
  deadline: {
    color: '#EF4444',
    bgColor: 'bg-red-100 dark:bg-red-900/30',
    textColor: 'text-red-600 dark:text-red-400',
    icon: Clock,
    label: 'Fecha Límite',
  },
  achievement: {
    color: '#FBBF24',
    bgColor: 'bg-yellow-100 dark:bg-yellow-900/30',
    textColor: 'text-yellow-600 dark:text-yellow-400',
    icon: Trophy,
    label: 'Logro',
  },
  info: {
    color: '#3B82F6',
    bgColor: 'bg-blue-100 dark:bg-blue-900/30',
    textColor: 'text-blue-600 dark:text-blue-400',
    icon: Info,
    label: 'Información',
  },
  warning: {
    color: '#F59E0B',
    bgColor: 'bg-yellow-100 dark:bg-yellow-900/30',
    textColor: 'text-yellow-600 dark:text-yellow-400',
    icon: AlertTriangle,
    label: 'Advertencia',
  },
  success: {
    color: '#10B981',
    bgColor: 'bg-green-100 dark:bg-green-900/30',
    textColor: 'text-green-600 dark:text-green-400',
    icon: CheckCircle,
    label: 'Éxito',
  },
  error: {
    color: '#EF4444',
    bgColor: 'bg-red-100 dark:bg-red-900/30',
    textColor: 'text-red-600 dark:text-red-400',
    icon: XCircle,
    label: 'Error',
  },
};

/**
 * Get configuration for a notification type
 */
export function getNotificationConfig(type: NotificationType): NotificationTypeConfig {
  return notificationTypeConfig[type] || notificationTypeConfig.info;
}

/**
 * Map legacy notification types to new types
 */
export function mapLegacyType(legacyType?: string): NotificationType {
  if (!legacyType) return 'info';

  const typeMap: Record<string, NotificationType> = {
    info: 'info',
    warning: 'warning',
    success: 'success',
    error: 'error',
    GLOBAL: 'announcement',
    COURSE: 'evaluation',
    LEVEL: 'announcement',
    USER: 'message',
    ADMIN: 'warning',
  };

  return typeMap[legacyType] || 'info';
}
